import React from 'react';

interface ButtonProps {
  onClick: () => void;
  children: React.ReactNode;
  className?: string; // 追加のクラスをオプションとして受け取る
}

export const Button: React.FC<ButtonProps> = ({
  onClick,
  children,
  className,
}) => {
  return (
    <button
      onClick={onClick}
      className={`bg-black text-white px-4 py-2 rounded ${className}`.trim()} // 共通のスタイル
    >
      {children}
    </button>
  );
};
